module.exports = "https://static.wmbcdn.com/uniweb/images/56ac53d3ee9e350cad13c04e2c6df7a5.svg";